import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Button from 'components/ui-components/Button';
import { useHTTP } from 'hooks/useRequest';
import CardTemplate from 'components/ui-templates/CardTemplate';
import LoadingSpinner from 'components/ui-components/loaders/LoadingSpinner';
import AlertBox from 'components/ui-components/AlertBox';

const ActivationSuccessful = () => {
  const [loading, setLoading] = useState(false);
  const [resend, setResend] = useState(false);

  const location = useLocation();
  const formData = location.state;

  const { customer } = formData;

  const requestConfig = {
    url: resend ? '/mycef/account/resend_activation_email' : null,
    method: 'post',
    data: { customer: { ...customer } },
  };

  const { error, data, loading: loadingData } = useHTTP(requestConfig);

  useEffect(() => {
    setLoading(loadingData);
  }, [loadingData]);

  const resendEmail = () => {
    setLoading(true);
    setResend(true);

    const timeout = setTimeout(() => {
      setLoading(false);
      setResend(false);
    }, 5000);

    // Clean up the timeout when the component unmounts or `submitted` changes
    return () => clearTimeout(timeout);
  };

  return (
    <>
      {resend && (data || error) && (
        <AlertBox
          variant={data ? 'success' : 'error'}
          showIcon={false}
          body={data?.message || error?.error.data.message}
          className="mb-24"
        />
      )}

      <CardTemplate
        title="Please verify your email address"
        description="We’ve sent an email verification link to"
        link={{ url: `mailto:${customer.email}`, text: customer.email }}>
        <p>
          Please click the <span className="fw-600">Verify Email</span> link in
          the email to continue setting up your account.
        </p>
        <div className="form-break" />
        <h3 className="fs-16 lh-1 fw-600 mt-0">Didn’t receive an email?</h3>
        <p className="fs-14">
          Please check your spam folder or resend the email.
        </p>
        <Button
          className="cef-btn cef-btn--feature cef-btn--green width-100 m-width-auto cef-btn--xxl mt-24"
          type="button"
          handleClick={() => resendEmail()}
          disabled={loading}>
          {loading ? <LoadingSpinner /> : 'Resend Email'}
        </Button>
      </CardTemplate>
    </>
  );
};

export default ActivationSuccessful;
